import { Component, ElementRef, OnInit, OnDestroy, ViewChild, HostListener, ViewContainerRef, ComponentRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthQuery } from '@auth/state/auth.query';
import { AuthService } from '@auth/state/auth.service';
import { AuthUser, PasswordChangeForm } from '@auth/state/auth.model';
import { Subscription } from 'rxjs';

import { ChangePasswordComponent } from '@app/auth/components/change-password/change-password.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('headermenu') headermenu!: ElementRef;
  @ViewChild('modalcontainer', { read: ViewContainerRef, static: true }) modalcontainer!: ViewContainerRef;
  
  changePasswordComponent: ComponentRef<ChangePasswordComponent> | null = null;

  user: undefined | AuthUser = undefined;
  is_admin = false;
  userSub!: Subscription;
  constructor( 
    private readonly router: Router,
    private readonly authQuery: AuthQuery,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    this.userSub = this.authQuery.user$.subscribe( user => {
      this.user = user;
      this.is_admin = this.user?.is_admin === "1" ? true: false;   
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }
  
  toggleMenu( event: Event ) {
    this.headermenu.nativeElement.classList.toggle("hidden");
    event.stopPropagation();
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login')
  }

  changePassword() {
    //const passwordChangeComponent = this.componentFactoryResolver.resolveComponentFactory( PasswordChangeComponent)

    this.modalcontainer.clear()
    this.changePasswordComponent = this.modalcontainer.createComponent( ChangePasswordComponent )
    
    this.changePasswordComponent.instance.onClose.subscribe( () => {
      setTimeout( () => this.changePasswordComponent?.destroy(), 800)
    })

    /**
     * password: ['', [ Validators.required, Validators.minLength(6) ] ],
      newPassword: ['', [ Validators.required, Validators.minLength(6) ] ],
      confirmPassword
     */
    this.changePasswordComponent.instance.onSave.subscribe( (payload: PasswordChangeForm) => {

      console.log('password', payload);
     // this.password?.setValue(password);
    //  this.password?.markAsDirty();

     // this.updateUser();
     this.authService.passwordChange( payload ).subscribe( (response) => {
        console.log('response', response);
        this.changePasswordComponent?.destroy();
      })
     // setTimeout( () => this.changePasswordComponent?.destroy(), 800)
    })
  }


  @HostListener('window:click', ['$event'])
  handleClick(event: MouseEvent) {
    this.headermenu.nativeElement.classList.add("hidden");
  }

}
